import { useEmbarcacaoSistemasDp } from "../../../../hooks/use-embarcacao-sistemas-dp";
import { EMPTY_FIELD_PLACEHOLDER, latestAtualizacao } from "../../../detail-format/detail-format";
import { buildDetailFields } from "../../../detail-format/detail-fields";
import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import {
  SISTEMAS_DP_EMPTY_STATE,
  SISTEMAS_DP_FIELDS,
  SISTEMAS_DP_ID,
  SISTEMAS_DP_LOADING_MESSAGE,
  SISTEMAS_DP_SECTION_TITLE,
  SISTEMAS_DP_TEST_ID,
} from "./sistemas-dp-section.constants";

/** Seção Sistemas de DP do detalhamento da embarcação: somente leitura, com os campos já formatados para a View. */
export function useSistemasDpSection({
  embarcacaoId,
  onReauthenticate,
}: EmbarcacaoDetailSectionProps) {
  const { status, sistemasDp, errorMessage, reload } = useEmbarcacaoSistemasDp(embarcacaoId);

  return {
    id: SISTEMAS_DP_ID,
    title: SISTEMAS_DP_SECTION_TITLE,
    testId: SISTEMAS_DP_TEST_ID,
    fieldsTestId: `${SISTEMAS_DP_TEST_ID}-fields`,
    status,
    errorMessage,
    loadingMessage: SISTEMAS_DP_LOADING_MESSAGE,
    emptyContent: SISTEMAS_DP_EMPTY_STATE,
    onReauthenticate,
    onRetry: reload,
    // Só há data de atualização a exibir quando a seção tem dados.
    ultimaAtualizacao: sistemasDp
      ? latestAtualizacao([sistemasDp.ultimaAtualizacao, sistemasDp.atualizacaoDp])
      : undefined,
    fields: buildDetailFields(
      sistemasDp,
      SISTEMAS_DP_FIELDS,
      SISTEMAS_DP_TEST_ID,
      EMPTY_FIELD_PLACEHOLDER,
    ),
  };
}
